import { buildModelManager } from "../builder.js";
const DefaultAgentChatV2Selection = {
  __typename: true,
  id: true,
  agentType: true,
  conversationId: true,
  createdAt: true,
  lastActivity: true,
  lastResponseId: true,
  localSessionId: true,
  messageCount: true,
  pendingSpecialMode: true,
  specialMode: true,
  status: true,
  title: true,
  tools: true,
  totalTokens: true,
  updatedAt: true,
  userId: true,
  vectorStoreId: true
};
const modelApiIdentifier = "agentChatV2";
const pluralModelApiIdentifier = "agentChatV2s";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByConversationId",
    findByField: "conversationId",
    findByVariableName: "conversationId",
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByConversationId",
    findByField: "conversationId",
    findByVariableName: "conversationId",
    modelApiIdentifier,
    defaultSelection: DefaultAgentChatV2Selection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAgentChatV2",
    operationReturnType: "CreateAgentChatV2",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      agentChatV2: { required: false, type: "CreateAgentChatV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentChatV2Selection
  },
  {
    type: "action",
    operationName: "bulkCreateAgentChatV2s",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAgentChatV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentChatV2Selection
  },
  {
    type: "action",
    operationName: "updateAgentChatV2",
    operationReturnType: "UpdateAgentChatV2",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      agentChatV2: { required: false, type: "UpdateAgentChatV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentChatV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpdateAgentChatV2s",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAgentChatV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentChatV2Selection
  },
  {
    type: "action",
    operationName: "deleteAgentChatV2",
    operationReturnType: "DeleteAgentChatV2",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAgentChatV2s",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAgentChatV2",
    operationReturnType: "UpsertAgentChatV2",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      agentChatV2: { required: false, type: "UpsertAgentChatV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAgentChatV2Result": { hasReturnType: false },
      "... on UpdateAgentChatV2Result": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentChatV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpsertAgentChatV2s",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAgentChatV2sInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAgentChatV2Selection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "agentChatV2GellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AgentChatV2Manager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAgentChatV2Selection,
  operations
);
export {
  AgentChatV2Manager,
  DefaultAgentChatV2Selection
};
//# sourceMappingURL=AgentChatV2.js.map
